/** Named by the backend after a correct checkout code, sent back on every checkout from this device. */
export const DEVICE_TOKEN_HEADER = 'x-otp-device-token';

/**
 * Sent with the code when the guest ticked "remember this device". The backend issues no token without
 * it: keeping one across visits needs the guest's own request under EU and UK cookie rules.
 */
export const REMEMBER_DEVICE_HEADER = 'x-otp-remember-device';

// A plain localStorage key, so one per shop domain, not per company: the backend binds the token
// to the phone and email the code was entered for and ends it after 30 days. Losing it (cleared
// storage, a reinstalled app) costs one more code, nothing else.
const STORAGE_KEY = 'otp_device_token';

/** The header naming this device, when it was remembered. */
export function rememberedDeviceHeaders(): Record<string, string> {
  try {
    const token = window.localStorage.getItem(STORAGE_KEY);

    return token ? { [DEVICE_TOKEN_HEADER]: token } : {};
  } catch {
    return {};
  }
}

/**
 * Keeps the token a checkout response hands out. Takes what BackendApiClient resolves with: the
 * axios response on success, the AxiosError otherwise (a 402 waiting on 3DS carries one too).
 */
export function rememberDevice(response: any): void {
  const headers = response?.headers ?? response?.response?.headers;
  const token = typeof headers?.get === 'function' ? headers.get(DEVICE_TOKEN_HEADER) : headers?.[DEVICE_TOKEN_HEADER];

  if (typeof token !== 'string' || token === '') {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Storage blocked (private mode, a full quota): the guest is asked for a code next time.
  }
}
